var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"availability"}},[_c('h5',[_vm._v("My availability")]),_c('calendar'),_c('p',{staticClass:"caption m-t-5 text-light"},[_vm._v("* Events are displayed in your local time zone, "+_vm._s(_vm.timezone))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }